<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Form Data Loading...
  </div>
  <b-card v-else no-body>
    <b-card-header>
      <span class="text-muted text-uppercase">{{ card_header }}</span>
    </b-card-header>
    <div class="py-3 px-4">
      <b-form-group >
        <b-row class="pr-3">
          <b-col
            v-for="(option, index) in collection"
            :key="index"
            cols="3"
            class="pr-0"
          >
            <b-form-checkbox
              :value="option.id"
              v-model="selected"
              :name="option.id"
              inline
            >
              {{ option.name }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-group>
      <custom-table-pagination
        :options="per_page_options"
        :current_page="current_page"
        :per_page="per_page"
        :total_rows="total_rows"
        @update="updatePaginationData"
      />
    </div>
  </b-card>
</template>

<script>
import CustomTablePagination from "@/components/shared/CustomTablePagination";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

export default {
  name: "CustomCheckboxSelectGroup",
  components: {
    CustomTablePagination,
  },
  props: {
    checked: {
      type: Array,
      default: () => [],
    },
    card_header: {
      type: String,
      default: null,
    },
    collection_type: {
      type: String,
      default: null,
    },
    field: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      collection: null,
      current_page: 1,
      per_page: 20,
      total_rows: 10,
      per_page_options: [10, 15, 20],
    };
  },
  computed: {
    labRepository() {
      return LabRepositoryFactory.get(this.collection_type);
    },
    selected: {
      get() {
        return this.checked;
      },
      set(value) {
        this.$emit("update", { field: this.field, value });
      },
    },
  },
  methods: {
    updatePaginationData({ field, value }) {
      this[field] = value;
      field === "per_page" && (this.current_page = 1);
      this.fetchCollection();
    },
    async fetchCollection() {
      this.loading = true;

      const { per_page, current_page } = this;
      const { data } = await this.labRepository.getSome({
        limit: per_page,
        page: current_page,
      });
      this.total_rows = data.total;
      this.collection = data.data;

      this.loading = false;
    },
  },
  created() {
    this.fetchCollection();
  },
};
</script>
